(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["number-counter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.number-counter-value');
    const updateCounter = (counter) => {
      const target = +counter.getAttribute('data-value');
      counter.innerText = '0';
      const increment = target / 200;

      const countUp = () => {
        const current = +counter.innerText;
        if (current < target) {
          counter.innerText = Math.ceil(current + increment);
          setTimeout(countUp, 5);
        } else {
          counter.innerText = target;
        }
      };

      countUp();
    };
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          updateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadLazyVideo(video) {
      if (video.dataset.loaded === 'true') return;

      var sources = video.querySelectorAll('source[data-src]');

      sources.forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.load();
      video.dataset.loaded = 'true';
    }

    function playVideo(video) {
      video.muted = true;
      video.playsInline = true;

      if (video.paused) {
        video.play().catch(function () {});
      }
    }

    function setupLazyVideos() {
      var videos = document.querySelectorAll('.video-grid video.lazy-video');

      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (video) {
          loadLazyVideo(video);
          playVideo(video);
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;

            if (entry.isIntersecting) {
              loadLazyVideo(video);
              playVideo(video);
            } else {
              if (!video.paused) {
                video.pause();
              }
            }
          });
        },
        {
          rootMargin: '300px 0px',
          threshold: 0.15
        }
      );

      videos.forEach(function (video) {
        if (video.dataset.lazyObserved === 'true') return;
        video.dataset.lazyObserved = 'true';
        observer.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupLazyVideos);
    } else {
      setupLazyVideos();
    }

    document.addEventListener('shopify:section:load', setupLazyVideos);
  })();

  } catch(e) { console.error(e); }
})();
})();
